import { Button, Typography } from '@mui/material'
import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../../../redux/store'
import FullScreenDialog from '../../../Common/Modal/FullScreenDialog/FullScreenDialog'
import { Task } from '../../../../redux/task/types'
import AssignedTeamMemberTable from './AssignedTeamMemberTable'

import { fetchAssignedTeamMembers } from '../../../../redux/reports/task/assignedTeamMemberPerTask/action'
import {
  clearFilters,
  clearInvitedTeamMembers,
} from '../../../../redux/reports/event/invitedTeamMemberPerEvent/slice'
import {
  fontLetterSpacings,
  fontLineHeights,
  fontSizes,
} from '../../../Common/Typography/TypographyStyles'

interface ViewTeamMemberTasksProps {
  taskDetails: Task
}

const ViewAssignedTeamMembers: React.FC<ViewTeamMemberTasksProps> = ({ taskDetails }) => {
  const dispatch = useDispatch<AppDispatch>()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (open) {
      dispatch(fetchAssignedTeamMembers({ taskId: String(taskDetails.id) }))
    }
  }, [dispatch, taskDetails.id, open])

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    dispatch(clearInvitedTeamMembers())
    dispatch(clearFilters())
  }

  return (
    <React.Fragment>
      <Button variant='contained' onClick={handleOpen}>
        View Report
      </Button>
      <FullScreenDialog
        show={open}
        onHide={handleClose}
        ariaLabelBy='viewInvitedTeamMembers'
        hasCloseBtn={true}
        headerContent={
          <Typography
            sx={{
              fontSize: fontSizes.size20,
              lineHeight: fontLineHeights.ratio9to8,
              letterSpacing: fontLetterSpacings.loose,
              fontWeight: 600,
            }}
          >
            {taskDetails.title}
          </Typography>
        }
        bodyContent={<AssignedTeamMemberTable />}
      />
    </React.Fragment>
  )
}

export default ViewAssignedTeamMembers
